'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _HomeDAO = require('../data/HomeDAO');

var _HomeDAO2 = _interopRequireDefault(_HomeDAO);

var _Loading = require('../templates/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _redirect = require('../utils/redirect');

var _redirect2 = _interopRequireDefault(_redirect);

var _urls = require('../utils/urls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RootEntry = function () {
  function RootEntry() {
    _classCallCheck(this, RootEntry);
  }

  _createClass(RootEntry, [{
    key: 'start',
    value: function start() {
      _hubspot2.default.getPortalIdFromQueryParam();
      this.page = document.getElementsByClassName('page')[0];

      this.renderLoading();
      _HomeDAO2.default.get().done(function (_ref) {
        var uri = _ref.uri;
        return (0, _redirect2.default)(uri);
      }).fail(this.homeFailure.bind(this));
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      this.page.appendChild((0, _Loading2.default)());
    }
  }, {
    key: 'homeFailure',
    value: function homeFailure(errorResp) {
      if (errorResp.status === 401 || errorResp.status === 403) {
        (0, _redirect2.default)((0, _urls.login)(window.location.href, _hubspot2.default.getPortalIdFromQueryParam()));
      } else {
        _Raven2.default.captureMessage('Home api error', {
          extra: {
            readyState: errorResp.readyState,
            responseText: errorResp.responseText,
            responseURL: errorResp.responseURL,
            status: errorResp.status,
            statusText: errorResp.statusText
          }
        });
        (0, _redirect2.default)((0, _urls.error)());
      }
    }
  }]);

  return RootEntry;
}();

new RootEntry().start();


//////////////////
// WEBPACK FOOTER
// ./js/entries/root.js
// module id = 38
// module chunks = 1